import * as Types from '../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSalesProfileMutationVariables = Types.Exact<{
  employeeId: Types.Scalars['String']['input'];
  iTalkExtension: Types.Scalars['String']['input'];
  hqlmUrl: Types.Scalars['String']['input'];
}>;


export type UpdateSalesProfileMutation = { __typename?: 'Mutation', updateSalesProfileInfo: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const UpdateSalesProfileDocument = gql`
    mutation updateSalesProfile($employeeId: String!, $iTalkExtension: String!, $hqlmUrl: String!) {
  updateSalesProfileInfo(
    parameter: {employeeId: $employeeId, iTalkExtension: $iTalkExtension, hqlmUrl: $hqlmUrl}
  ) {
    count
    error
  }
}
    `;
export type UpdateSalesProfileMutationFn = Apollo.MutationFunction<UpdateSalesProfileMutation, UpdateSalesProfileMutationVariables>;

/**
 * __useUpdateSalesProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSalesProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesProfileMutation, { data, loading, error }] = useUpdateSalesProfileMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      iTalkExtension: // value for 'iTalkExtension'
 *      hqlmUrl: // value for 'hqlmUrl'
 *   },
 * });
 */
export function useUpdateSalesProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesProfileMutation, UpdateSalesProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesProfileMutation, UpdateSalesProfileMutationVariables>(UpdateSalesProfileDocument, options);
      }
export type UpdateSalesProfileMutationHookResult = ReturnType<typeof useUpdateSalesProfileMutation>;
export type UpdateSalesProfileMutationResult = Apollo.MutationResult<UpdateSalesProfileMutation>;
export type UpdateSalesProfileMutationOptions = Apollo.BaseMutationOptions<UpdateSalesProfileMutation, UpdateSalesProfileMutationVariables>;